import React from 'react';
import { Box, ListItem } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export const ThreadItemSkeleton = () => (
    <ListItem
        style={{
            display: 'flex',
            gap: 15,
            minHeight: 88,
            paddingTop: 12,
            paddingBottom: 12,
        }}
    >
        <Skeleton variant="circle" width={56} height={56} animation="wave" />
        <Box flexGrow={1} minWidth={0}>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
            >
                <Skeleton variant="text" width="45%" animation="wave" />
                <Skeleton variant="text" width="25%" animation="wave" />
            </Box>
            <Skeleton variant="text" width="85%" animation="wave" />
            <Skeleton variant="text" width="55%" animation="wave" />
        </Box>
    </ListItem>
);
